<app-header #headerRef />
<section class="error-container">
  <mat-card appearance="outlined" class="error-card animation-description fadeInDown">
    <mat-card-header>
      <!-- <mat-card-title i18n>We are Sorry</mat-card-title> -->
      <mat-card-title i18n>You are not authorized to view this page.</mat-card-title>
    </mat-card-header>
  </mat-card>
</section>
